
  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getStorage } from "firebase/storage";
  // import { getDatabase } from "firebase/database"
  import { getFirestore } from "firebase/firestore";
  

const firebaseConfig = {
  apiKey: "AIzaSyAZBnMKxs87NGGxYfgPI-Ir3kRt1Iv_j8o",

  authDomain: "marketchipping-data.firebaseapp.com",

  projectId: "marketchipping-data",

  storageBucket: "marketchipping-data.firebasestorage.app",

  messagingSenderId: "315836018221",

  appId: "1:315836018221:web:7b2538cfb748ae34dc92a4"

};


  // Initialize Firebase
  const app = initializeApp(firebaseConfig);


// Firebase storage reference
const storage = getStorage(app);
export default storage;

export const database = getFirestore(app);

